import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const CardFooter = ({muted, children, className}) => {
  const cardClass = classNames('card-footer', className, {
    'bg-light': muted
  });
  return (
    <div className={cardClass}>
      {children}
    </div>
  );
};

CardFooter.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node
  ]),
  muted: PropTypes.bool,
  className: PropTypes.string
};

export default CardFooter;
